import React from 'react'
import { useContext, useState } from 'react'
import { CandidatesContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCandidateMedicineInfo, saveCandidateMedicineInfo } from '../../../actions/candidates'
import styles from './styles.module.scss'
import Button from '../../../components/Button'
import { Checkbox, Textarea } from '../../../components/ModalInputs'
import Table from '../../../components/Table'
import { useFormik } from 'formik'


export default function Medicine() {

  const { candidateId, closeModal } = useContext(CandidatesContext)
  const dispatch = useDispatch()
  const { medicine_info: data } = useSelector(state => state.candidates.data)

  const [missingDocs, setMissingDocs] = useState([])
  const [selectedDoc, setSelectedDoc] = useState(null)

  useEffect(() => {
    candidateId !== 'add' && dispatch(getCandidateMedicineInfo(candidateId))
  }, [])

  useEffect(() => {
    if (data?.missing_documents) {
      setMissingDocs(data.missing_documents)
    }
  }, [data])

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: (formData) => {
      const dataToSave = {
        ...formData,
        missing_documents: missingDocs
      }
      dispatch(saveCandidateMedicineInfo(candidateId, dataToSave))
    }
  })

  const handleAddDoc = () => {
    const newDoc = {
      id: Date.now(),
      name: '',
      note: '',
      status: 'Ожидает',
      updated_at: new Date().toLocaleDateString('ru-RU')
    }
    setMissingDocs([...missingDocs, newDoc])
  }

  const handleDeleteDoc = () => {
    if (selectedDoc) {
      setMissingDocs(missingDocs.filter(doc => doc.id !== selectedDoc))
      setSelectedDoc(null)
    }
  }

  const handleAcceptDoc = () => {
    if (selectedDoc) {
      setMissingDocs(missingDocs.map(doc =>
        doc.id === selectedDoc ? { ...doc, status: 'Принят' } : doc
      ))
    }
  }

  const handleRejectDoc = () => {
    if (selectedDoc) {
      setMissingDocs(missingDocs.map(doc =>
        doc.id === selectedDoc ? { ...doc, status: 'Отклонён' } : doc
      ))
    }
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Checkbox
              label='Готов к поступлению'
              name='ready_to_admission'
              checked={values.ready_to_admission || false}
              onChange={(e) => setFieldValue('ready_to_admission', e.target.checked)}
            />
          </div>
          <div className={styles.inputsRow}>
            <Textarea
              style={{ resize: 'none', width: '750px', height: '150px' }}
              label='Состояние здоровья'
              name='health_status'
              value={values.health_status || ''}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Textarea
              style={{ resize: 'none', width: '550px', height: '150px' }}
              label='Очный осмотр'
              name='medical_examination'
              value={values.medical_examination || ''}
              onChange={handleChange}
            />
            <Checkbox
              label='Не допущен к дальнейшему прохождению вступительных испытаний по результатам очного осмотра'
              name='not_allowed'
              checked={values.not_allowed || false}
              onChange={(e) => setFieldValue('not_allowed', e.target.checked)}
            />
          </div>
          <p>Не хватает документов</p>
          <div className={styles.scheduleButtons} style={{ marginBottom: '0.5rem' }}>
            <Button mode='bordered' onClick={() => dispatch(getCandidateMedicineInfo(candidateId))}>Получить</Button>
            <Button
              mode='bordered'
              disabled={!selectedDoc}
              onClick={() => {
                const doc = missingDocs.find(d => d.id === selectedDoc)
                const url = doc?.url || doc?.file_url
                if (url) window.open(url, '_blank')
              }}
            >Просмотр</Button>
          </div>
          <Table style={{ maxHeight: '200px' }}>
            <thead>
              <tr>
                <th>Название документа (файл)</th>
                <th>Примечание/Причина</th>
                <th>Статус</th>
                <th>Обновлен</th>
              </tr>
            </thead>
            <tbody>
              {missingDocs.map((doc) => (
                <tr
                  key={doc.id}
                  onClick={() => setSelectedDoc(doc.id)}
                  className={selectedDoc === doc.id ? styles.selectedTableRow : ''}
                >
                  <td>
                    <input
                      style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none' }}
                      value={doc.name || ''}
                      onChange={(e) => setMissingDocs(prev =>
                        prev.map(d => d.id === doc.id ? { ...d, name: e.target.value } : d)
                      )}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                  <td>
                    <input
                      style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none' }}
                      value={doc.note || ''}
                      onChange={(e) => setMissingDocs(prev =>
                        prev.map(d => d.id === doc.id ? { ...d, note: e.target.value } : d)
                      )}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                  <td>
                    <select
                      style={{ border: 'none', background: 'transparent', outline: 'none' }}
                      value={doc.status || 'Ожидает'}
                      onChange={(e) => setMissingDocs(prev =>
                        prev.map(d => d.id === doc.id ? { ...d, status: e.target.value } : d)
                      )}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <option>Ожидает</option>
                      <option>Принят</option>
                      <option>Отклонён</option>
                    </select>
                  </td>
                  <td>{doc.updated_at}</td>
                </tr>
              ))}
              {missingDocs.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>
                    Нет данных
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className={styles.scheduleButtons}>
            <Button mode='bordered' onClick={handleAddDoc}>Добавить</Button>
            <Button mode='bordered' onClick={handleDeleteDoc}>Удалить</Button>
            <Button mode='bordered' onClick={handleAcceptDoc}>Принять</Button>
            <Button mode='bordered' onClick={handleRejectDoc}>Отклонить</Button>
          </div>
        </div>
      </div>
      <div className={styles.modalFooter}>
        <div>
          <div>Создал: {data?.created_by || ''} {data?.created_at || ''}</div>
          <div>Изменил: {data?.updated_by || ''} {data?.updated_at || ''}</div>
        </div>
        <Button mode='white' onClick={handleSubmit}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </>
  )
}
